import { Button, OpenWord } from '../../../ui';

/**
 * A READ THAT FAILED, SAID WHERE ITS CONTENT WOULD BE (DESIGN.md H7, D13): one line in the
 * product's sentence for it, "<The things> could not be loaded.", and "Try again", never an empty
 * list, a zero or the server's message. Words no register line decided carry their OPEN id
 * (`openWord`, D4); the sentences of the night round are the owner's since register A9-1.
 */
export function LoadErrorLine({
  what,
  onRetry,
  openWord,
}: {
  /** "The calls": the subject of the sentence. */
  readonly what: string;
  readonly onRetry: () => void;
  readonly openWord?: string | undefined;
}) {
  const sentence = `${what} could not be loaded.`;
  return (
    <p className="flex flex-wrap items-baseline gap-x-3 text-sm text-ink" data-load-error="">
      <span>
        {openWord === undefined ? sentence : <OpenWord id={openWord}>{sentence}</OpenWord>}
      </span>
      <Button variant="text" onClick={onRetry}>
        Try again
      </Button>
    </p>
  );
}
